import Accordion from './modules/Accordion.js';
import AnchorNav from './modules/AnchorNav.js';
import initBlogDetail from './modules/BlogDetail.js';
import BlogFilter from './modules/BlogFilter.js';
import initGlossary from './modules/Glossary.js';
import LangSwitch from './modules/LangSwitch.js';
import Layout484 from './modules/Layout484.js';
import { initContactProtect } from './modules/ContactProtect.js';
import { initLightbox } from './modules/Lightbox.js';
import Logo4 from './modules/Logo4.js';
import Navigation from './modules/Navigation.js';
import NewsFilter from './modules/NewsFilter.js';
import NewsletterSubscribe from './modules/NewsletterSubscribe.js';
import { initTracking } from './modules/Tracking.js';
import { initCtaModal } from './modules/CtaModal.js';

const modules = {
    Accordion,
    AnchorNav,
    BlogFilter,
    LangSwitch,
    Layout484,
    Logo4,
    Navigation,
    NewsFilter,
    NewsletterSubscribe,
};

document.addEventListener('DOMContentLoaded', () => {
    // Module initialisieren nur wenn data-module Element auf der Seite existiert
    const components = document.querySelectorAll('[data-module]');

    for (const el of components) {
        const componentName = el.dataset.module;

        if (modules[componentName]) {
            new modules[componentName](el);
        }
    }

    // GLightbox global initialisieren (kein data-module noetig)
    initLightbox();

    // Glossar-Tooltip initialisieren (sucht selbst die .glossary-Elemente)
    initGlossary();

    // Blog-Detail: Auto-Nummerierung H2 + TOC-Build
    initBlogDetail();

    // Verschleierte Kontaktlinks (E-Mail/Telefon) enthüllen — VOR Tracking,
    // damit das href steht, wenn contact_click gebunden wird.
    initContactProtect();

    // Interaktions-Tracking (Downloads/Outbound/Kontakt/Custom) ins dataLayer
    initTracking();

    // CTA-Modal: Formulare aus CTA-Buttons als AJAX-Modal öffnen (data-modal-form)
    initCtaModal();

    // Form-Tracking: dataLayer-Event bei Absenden jedes EXT:form-Formulars.
    // Container-frei (GTM/GA4 später andockbar). EXT:form erkennbar am hidden-Feld
    // tx_form_formframework[...]; form_id = form-Identifier (= id-Attribut).
    document.querySelectorAll('form input[name^="tx_form_formframework"]').forEach((field) => {
        const form = field.closest('form');
        if (!form || form.dataset.trackingBound) return;
        form.dataset.trackingBound = '1';
        form.addEventListener('submit', () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'form_submit',
                form_id: form.getAttribute('id') || 'unknown',
            });
        });
    });

    // Fortschrittsbalken füllen (Schritt X von Y) — Fluid kann die Breite
    // nicht arithmetisch ins style-Attribut schreiben, daher hier per JS.
    document.querySelectorAll('.wpw-form__progress-bar').forEach((bar) => {
        const step = parseInt(bar.dataset.step || '1', 10);
        const total = parseInt(bar.dataset.total || '1', 10);
        if (total > 0) {
            bar.style.width = Math.round((step / total) * 100) + '%';
        }
    });

    // Sanftes Scrollen zu In-Page-Ankern (#c123, #pakete, ...) für ALLE Hash-Links,
    // die nicht schon von der AnchorNav-Komponente behandelt werden. Fixt native
    // Anker-Sprünge, die unter dem Sticky-Header sonst nicht scrollen (z. B. Hero-CTA
    // "SEO-Check anfragen", Paket- und Prefooter-CTAs, bestehender #pakete-Button).
    (function initHashScroll() {
        const headerOffset = () => {
            const h = document.querySelector('[data-module="Navigation"], header');
            if (!h) return 16;
            const pos = getComputedStyle(h).position;
            return pos === 'fixed' || pos === 'sticky' ? h.offsetHeight + 16 : 16;
        };
        // window.scrollTo ist auf diesem Theme wirkungslos, und animiertes Scrollen
        // stockt wegen der schweren Scroll-Listener (Wort-Animation, Reading-Dock).
        // Daher direkt das scrollingElement setzen (instant) + Nachkorrektur, falls
        // Lazy-Load-Bilder das Layout nach dem Sprung noch verschieben.
        const scrollToTarget = (target) => {
            const se = document.scrollingElement || document.documentElement;
            let tries = 0;
            // Wiederholt nachjustieren, bis das Ziel unter dem Sticky-Header sitzt.
            // Fängt progressives Nachladen von Lazy-Load-Bildern ab, das die
            // Zielposition während des Sprungs weiter nach unten schiebt.
            const settle = () => {
                const top = target.getBoundingClientRect().top;
                const off = headerOffset();
                if (Math.abs(top - off) > 4 && tries < 15) {
                    se.scrollTop = se.scrollTop + top - off;
                    tries += 1;
                    setTimeout(settle, 110);
                }
            };
            settle();
        };
        document.addEventListener('click', (e) => {
            const link = e.target.closest('a[href]');
            if (!link || link.hasAttribute('data-anchor-link')) return; // AnchorNav übernimmt
            let url;
            try {
                url = new URL(link.href, window.location.href);
            } catch (err) {
                return;
            }
            if (url.pathname !== window.location.pathname || url.hash.length < 2) return;
            const target = document.getElementById(decodeURIComponent(url.hash.substring(1)));
            if (!target) return;
            e.preventDefault();
            scrollToTarget(target);
            history.pushState(null, '', url.hash);
        });
        // Direktaufruf mit #hash: unter den Sticky-Header scrollen, sobald das Layout steht.
        if (window.location.hash.length > 1) {
            const target = document.getElementById(
                decodeURIComponent(window.location.hash.substring(1))
            );
            if (target) {
                requestAnimationFrame(() =>
                    requestAnimationFrame(() => scrollToTarget(target))
                );
            }
        }
    })();
});
